import config from "../config/config"
import { callService } from "./CommonService";

const APIUrlBase = config.apiHost + config.apiBase + 'dashboard';

/* Retrieve dashboard statistics, optionally scoped to a specific year */
async function getStats(year) {
    const url = year ? `${APIUrlBase}?year=${year}` : APIUrlBase;
    return await callService(url);
}

export default { getStats };
